import { routerPageRoot, PageErrorBoundary } from "@/app/config/router";
import { RouteObject, redirect } from "react-router-dom";
import env from "@/app/config/env";
import { useLoader } from "@/app/hook/use-loader";

export const routerRoot: RouteObject = {
  ...routerPageRoot,
  errorElement: <PageErrorBoundary />,
  HydrateFallback: () => {
    const { setLoader } = useLoader();
    setLoader(true);
  },
  children: [
    {
      index: true,
      loader: () => redirect(`/${env.app.defaultLang}/home`),
    },
  ],
};
